import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_USER_GET_BY_ACTIVATION } from 'api/utilityActionTypes';

export default async function getUtilityActivation(
  { state, utilityApiClient },
  { utilityUserId, forceRefresh = false },
) {
  typeCheck('utilityUserId::PositiveNumber', utilityUserId);

  const currentStatePath = ['utilityUser', 'utilityActivation'];
  if (state.get(currentStatePath) && !forceRefresh) {
    return state.get(currentStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_USER_GET_BY_ACTIVATION,
    state: state,
    payload: {
      utilityUserId: utilityUserId,
    },
    onSuccess(utilityActivation) {
      if (utilityActivation) {
        state.set(currentStatePath, utilityActivation);
      }
    },
  });
}
